import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { assetApi, type Asset } from '../../api/media';

export function AssetLibraryPage() {
  const [items, setItems] = useState<Asset[]>([]);
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    void assetApi
      .list(status ? { status } : undefined)
      .then(setItems)
      .catch((e) => setError(String(e)))
      .finally(() => setLoading(false));
  }, [status]);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <div className="flex flex-wrap justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold">Digital Asset Library</h1>
          <p className="mt-1 text-sm text-slate-600">Product media, marketplace images, videos, and AI assets.</p>
        </div>
        <div className="flex flex-wrap gap-3 text-sm">
          <Link to="/media/search" className="text-slate-700 hover:underline">Search</Link>
          <Link to="/media/bulk-upload" className="text-slate-700 hover:underline">Bulk upload</Link>
          <Link to="/media/approval" className="text-slate-700 hover:underline">Approval queue</Link>
          <Link to="/media/duplicates" className="text-slate-700 hover:underline">Duplicates</Link>
          <Link to="/media/prompts" className="text-slate-700 hover:underline">Prompt library</Link>
        </div>
      </div>
      <select value={status} onChange={(e) => setStatus(e.target.value)} className="mt-6 rounded-lg border px-3 py-2 text-sm">
        <option value="">All statuses</option>
        <option value="draft">Draft</option>
        <option value="pending_approval">Pending approval</option>
        <option value="approved">Approved</option>
        <option value="published">Published</option>
        <option value="archived">Archived</option>
      </select>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {loading ? <p className="mt-6">Loading…</p> : (
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((a) => (
            <Link key={a.id} to={`/media/assets/${a.id}`} className="rounded-xl border bg-white p-4 hover:shadow-sm">
              {a.thumbnail_url || a.file_url ? (
                <img src={a.thumbnail_url || a.file_url} alt={a.name} className="mb-3 h-32 w-full rounded-lg object-cover" />
              ) : (
                <div className="mb-3 flex h-32 items-center justify-center rounded-lg bg-slate-100 text-slate-400">{a.type}</div>
              )}
              <p className="font-medium">{a.name}</p>
              <p className="text-xs capitalize text-slate-500">{a.status.replace(/_/g, ' ')} · {a.type}</p>
            </Link>
          ))}
          {items.length === 0 && <p className="text-slate-500">No assets found.</p>}
        </div>
      )}
    </div>
  );
}
